import { useState } from 'react';

import styles from './carousel.module.css';

const Carousel = ({carouselRef, children, additionalStyle}) => {

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const onMouseDown = (e) => {
    setIsDragging(true);
    if (document.selection) {
      document.selection.empty()
    } else {
      window.getSelection().removeAllRanges()
    }
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;

    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX); 
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const onMouseUp = () => {
    setIsDragging(false);
    if (document.selection) {
      document.selection.empty()
    } else {
      window.getSelection().removeAllRanges()
    }
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  return (
    <div
      ref={carouselRef}
      className={`${styles.Carousel} ${additionalStyle ? additionalStyle : ''}`}
      style={{cursor: `${isDragging ? 'grabbing' : 'grab'}`}}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}>
      {children}
    </div>
  )
}

export default Carousel;